module.exports = __webpack_public_path__ + "static/img/border-3.0d16eb61.png";